import { apiClient } from './client';
import type { SarAccount } from '@/types/oscar';

/**
 * System Access Reviews read view (oscar/api/Functions/AccessReviewsFunctions.cs).
 * The access landscape over oscar.vAccount — every account with its Account
 * Type, owner, enabled state and last sign-in / password change. Any Oscar role
 * can read it.
 */
export function listAccessReviewAccounts(signal?: AbortSignal): Promise<SarAccount[]> {
  return apiClient.get<SarAccount[]>('/api/access-reviews/accounts', signal);
}
